import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { AdministrationForm } from './AdministrationForm';
import { TitledPage } from '@client/new/components/Misc';
import { PrimaryButton } from '@client/new/components/button';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useAdministrationViewModel } from './useAdministration.viewModel';

type AdministrationProps = {
  params: {
    influencerId: string;
  };
};

export const Administration = (props: AdministrationProps) => {
  const influencerId = Number(props.params.influencerId);
  const viewModel = useAdministrationViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Administration">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage
          title="Administration"
          rightContent={
            data ? (
              <PrimaryButton
                onClick={() => data.dispatch('updateInfluencer')}
                className="h-[40px]"
                disabled={data.submittingUpdate}
              >
                Save changes
              </PrimaryButton>
            ) : null
          }
        >
          <AdministrationForm {...data} />
        </TitledPage>
      )}
    />
  );
};
